import axios from 'axios'
import { GET_USERS_ERRORS, GET_USER, GET_USERS, USERS_LOADING } from './types'
import { resetErrors } from './errorsActions'

//GET USERS
export const getUsers = () => dispatch => {
  dispatch(setUsersLoading())

  axios
    .get('/api/users')
    .then(res => {
      dispatch({
        type: GET_USERS,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({ type: GET_USERS_ERRORS, payload: err.response.data })
    })
}

//GET USER
export const getUser = user_id => dispatch => {
  dispatch(setUsersLoading())
  dispatch(resetErrors)

  axios
    .get('/api/users/' + user_id)
    .then(res => {
      dispatch({
        type: GET_USER,
        payload: res.data,
      })
    })
    .catch(err => {
      dispatch({ type: GET_USERS_ERRORS, payload: err.response.data })
    })
}

export const setUsersLoading = () => {
  return { type: USERS_LOADING }
}
